/* This is a generated file of CSS imports */
/* It was generated by @jupyterlab/builder in Build.ensureAssets() */

import '@jupyter-notebook/application-extension/style/index.js';
import '@jupyter-notebook/application/style/index.js';
import '@jupyter-notebook/console-extension/style/index.js';
import '@jupyter-notebook/docmanager-extension/style/index.js';
import '@jupyter-notebook/documentsearch-extension/style/index.js';
import '@jupyter-notebook/help-extension/style/index.js';
import '@jupyter-notebook/notebook-extension/style/index.js';
import '@jupyter-notebook/terminal-extension/style/index.js';
import '@jupyter-notebook/tree-extension/style/index.js';
import '@jupyter-notebook/ui-components/style/index.js';
import '@jupyterlab/application-extension/style/index.js';
import '@jupyterlab/apputils-extension/style/index.js';
import '@jupyterlab/audio-extension/style/index.js';
import '@jupyterlab/cell-toolbar-extension/style/index.js';
import '@jupyterlab/celltags-extension/style/index.js';
import '@jupyterlab/codemirror-extension/style/index.js';
import '@jupyterlab/completer-extension/style/index.js';
import '@jupyterlab/console-extension/style/index.js';
import '@jupyterlab/csvviewer-extension/style/index.js';
import '@jupyterlab/debugger-extension/style/index.js';
import '@jupyterlab/docmanager-extension/style/index.js';
import '@jupyterlab/documentsearch-extension/style/index.js';
import '@jupyterlab/extensionmanager-extension/style/index.js';
import '@jupyterlab/filebrowser-extension/style/index.js';
import '@jupyterlab/fileeditor-extension/style/index.js';
import '@jupyterlab/help-extension/style/index.js';
import '@jupyterlab/htmlviewer-extension/style/index.js';
import '@jupyterlab/hub-extension/style/index.js';
import '@jupyterlab/imageviewer-extension/style/index.js';
import '@jupyterlab/javascript-extension/style/index.js';
import '@jupyterlab/json-extension/style/index.js';
import '@jupyterlab/logconsole-extension/style/index.js';
import '@jupyterlab/lsp-extension/style/index.js';
import '@jupyterlab/mainmenu-extension/style/index.js';
import '@jupyterlab/markdownviewer-extension/style/index.js';
import '@jupyterlab/markedparser-extension/style/index.js';
import '@jupyterlab/mathjax-extension/style/index.js';
import '@jupyterlab/mermaid-extension/style/index.js';
import '@jupyterlab/metadataform-extension/style/index.js';
import '@jupyterlab/notebook-extension/style/index.js';
import '@jupyterlab/pdf-extension/style/index.js';
import '@jupyterlab/pluginmanager-extension/style/index.js';
import '@jupyterlab/running-extension/style/index.js';
import '@jupyterlab/settingeditor-extension/style/index.js';
import '@jupyterlab/shortcuts-extension/style/index.js';
import '@jupyterlab/terminal-extension/style/index.js';
import '@jupyterlab/toc-extension/style/index.js';
import '@jupyterlab/tooltip-extension/style/index.js';
import '@jupyterlab/translation-extension/style/index.js';
import '@jupyterlab/ui-components-extension/style/index.js';
import '@jupyterlab/vega5-extension/style/index.js';
import '@jupyterlab/video-extension/style/index.js';
